import { SharedCartOrganization } from '@/modules/cart/shared/types';
import { TableOptions } from '@/types';
import { BaseState } from '@/store/base-state';
import { Orders } from '@/modules/orders/types';
import {
  Dispatches, DispatchesFilters, DownloadFilters,
} from '../types';
import { default_dispatch_details, default_dispatch_corrective } from '../services';

export default class DispatchesState extends BaseState {
  dispatches_list: Dispatches.Dispatch[] = [];
  user_organizations: Orders.OrderOrganization | [] = [];
  organizations_external: Record<'name', string>[] | [] = [];
  contracts: Record<'name', string>[] | [] = [];
  dispatches_loading = false;
  dispatch_details: Dispatches.DispatchDetailedInfo = default_dispatch_details();
  dispatch_corrective: Dispatches.DispatchСorrective = default_dispatch_corrective();
  dispatch_returns: Dispatches.DispatchReturn[] = [];
  documents_data_dialog: Dispatches.DispatchDocument[] = [];
  dispatch_as_document: Dispatches.ExelInfo = {} as Dispatches.ExelInfo;
  categories: Dispatches.Categories[] = [];
  products: Dispatches.Products[] = [];
  is_download = false;
  filters: DispatchesFilters = {
    search: '',
    organization_external: null,
    organization: null,
    contract: null,
    date: [],
    only_has_unread_changes: false,
  };

  filters_download: DownloadFilters = {
    category_ids: [],
    product_ids: [],
    organization_ids: [],
    dates: [],
  }

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
